const linkGroups = [
  {
    title: "浏览分区",
    links: [
      { label: "真假看板", href: "#board" },
      { label: "合集索引", href: "#collections" },
      { label: "反转事件", href: "#reversals" },
      { label: "声明汇总", href: "#statements" },
    ],
  },
  {
    title: "跟踪方式",
    links: [
      { label: "回应时间线", href: "#timeline" },
      { label: "社区讨论", href: "#discussions" },
      { label: "辟谣小课堂", href: "#classroom" },
      { label: "更新说明", href: "#board" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "核验标准", href: "#classroom" },
      { label: "状态标注规则", href: "#board" },
      { label: "纠错与反馈", href: "#discussions" },
      { label: "免责与版权", href: "#classroom" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-search-eye-line text-lg w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                蝌蚪黑料
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              蝌蚪黑料辟谣与反转专区，集中跟踪真假变化、涉事声明和相关后续。每条信息都标注当前状态，证据不足时只说待核实。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs font-label text-foreground-700 whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                已辟谣 1,284
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs font-label text-foreground-700 whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
                出现反转 326
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs font-label text-foreground-700 whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-secondary-500" />
                待核实 517
              </span>
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-foreground-950">
                <a href="#top" className="hover:text-primary-700 transition-colors">
                  {group.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm font-label text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              aria-label="回到顶部"
              className="w-11 h-11 rounded-md bg-background-50 border border-secondary-200 text-foreground-700 hover:text-primary-700 hover:border-primary-300 transition-colors flex items-center justify-center cursor-pointer"
            >
              <i className="ri-arrow-up-line text-lg w-5 h-5 flex items-center justify-center" />
            </button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label text-foreground-600 text-center sm:text-left">
            © 2026 蝌蚪黑料 · 本站内容为公开信息整理，仅供对照参考，不构成任何事实认定。
          </p>
          <p className="text-xs font-label text-foreground-500 text-center sm:text-right">
            页面状态最后同步：2026-09-10 12:05
          </p>
        </div>
      </div>
    </footer>
  );
}